var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormatLineSpacing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 897 80 737l42-42 88 86V373l-88 86-42-42 160-160 160 160-42 42-88-86v408l88-86 42 42-160 160Zm240-41v-60h400v60H480Zm0-250v-60h400v60H480Zm0-250v-60h400v60H480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatLineSpacing);
export default __webpack_public_path__ + "static/media/format_line_spacing.b7117c6d201ffcda8db1524615d72777.svg";
export { ForwardRef as ReactComponent };